import axios from "axios";
import config from "../Config.json";

const RejectUser = async (userId,payload) => {
    try {
        const AuthToken = localStorage.getItem('token')
        axios.defaults.headers.common['Authorization'] = AuthToken;

        const response = await axios.post(`${config.API_URL}/app/rejectUser/${userId}`,payload)
        return response

    } catch (error) {
        return error
    }
}

export default RejectUser;